export default "__VITE_ASSET__BDVgsMYH__"